import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Tabs, { ITabsProps } from 'tbk-components/src/components/Tabs';
import Tab, { ITabProps } from 'tbk-components/src/components/Tab';
import DonationForm, {
	IDonationFormProps,
} from './DonorToolComponents/DonationForm';
import LocationMap, { ILocationMapProps } from '../LocationMap';
import DonorToolGravityFormContainer, {
	IDonorToolGravityFormContainerProps,
} from './DonorToolComponents/DonorToolGravityFormContainer';

export interface IDonorToolProps extends IBaseElementProps {
	children?: any;
	introTitle?: string;
	introText?: string;
	nationMapProps?: ILocationMapProps;
	whereMostNeededDonationFormProps?: IDonationFormProps;
	byDonationCodeDonationFormProps?: IDonationFormProps;
	sponsorshipFormContainerProps?: IDonorToolGravityFormContainerProps;
	plannedGivingFormContainerProps?: IDonorToolGravityFormContainerProps;
}

const DonorTool: React.FC<IDonorToolProps> = ({
	children,
	className,
	classNames = [],
	introTitle,
	introText,
	nationMapProps,
	whereMostNeededDonationFormProps,
	byDonationCodeDonationFormProps,
	sponsorshipFormContainerProps,
	plannedGivingFormContainerProps,
}) => (
	<div className={className || cn('donor-tool', ...classNames)}>
		<div className="donor-tool__container container-fluid">
			<div className="donor-tool__intro-content">
				{introTitle && (
					<h1 className="h2 donor-tool__intro-title">{introTitle}</h1>
				)}
				{introText && (
					<p className="donor-tool__intro-text">{introText}</p>
				)}
			</div>
			<Tabs>
				<Tab title="Where Most Needed">
					<DonationForm {...whereMostNeededDonationFormProps} />
				</Tab>
				<Tab title="By Donation Code">
					<DonationForm {...byDonationCodeDonationFormProps} />
				</Tab>
				<Tab title="Nation Map">
					<LocationMap {...nationMapProps} />
				</Tab>
				<Tab title="Sponsorship">
					<DonorToolGravityFormContainer
						{...sponsorshipFormContainerProps}
					/>
				</Tab>
				<Tab title="Planned Giving">
					<DonorToolGravityFormContainer
						{...plannedGivingFormContainerProps}
					/>
				</Tab>
			</Tabs>
		</div>
	</div>
);

export default DonorTool;
